import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { Spin, Row, Col, Select } from 'antd';
import { isEmpty, isUndefined } from 'lodash';
import { Link } from 'react-router-dom';

import {
    loadDelegatedWaitingForApprovalReports,
} from '../actions';
import * as constants from '../constants';

import uistate from '../../uistate';
import common from '../../../common';
import core from '../../core';
import globalappstate from '../../globalappstate';
import currentuser from '../../currentuser';

const { loadUserCounters } = currentuser.actions;

const { AgGridWithState } = core;
const { RendererBoolean, RendererStatus } = common;

class DelegatedWaitingForApprovalReportsGrid extends Component {

    state = {
        selectedIdReport: '',
    }

    UNSAFE_componentWillMount() {
        this.props.loadDelegatedWaitingForApprovalReports();
        this.props.loadUserCounters();
    }
    onSelect = (dataitem) => {
        //console.log('selected', dataitem);
        this.setState({
            selectedIdReport: dataitem.idReport,
        });
    }
    onDoubleClick = (dataitem) => {
        //console.log('selected', dataitem);
        this.setState({
            selectedIdReport: dataitem.idReport,
         });
        this.props.history.push(`/app/reports/${dataitem.idReport}`, { from: window.location.pathname });
    }
    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'DelegatedWaitingForApprovalReportsGrid', key);
    }
    nrFormatter = (params) => {
        if (params.value) {
            return Number(params.value).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2});
        } else {
            return ''
        }
    }
    getGridCols = () => {
        let cols = [
            { key: "status", headerName: this.label("Status"), field: "status", sortable: true, filter: false, enableRowGroup: true, suppressHeaderMenuButton: true, width: 80, minWidth: 80, maxWidth: 80, cellRenderer: 'rendererStatus' },
            { key: "company", width: 70, headerName: this.label("Company"), field: "company", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { key: "number",width: 110, minWidth: 110, maxWidth: 110, headerName: this.label("Number"), field: "number", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { key: "type", width: 70, headerName: this.label("Type"), field: "type", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true },
            { key: "personnelNumber", headerName: this.label("PersonnelNumber"), field: "personnelNumber", sortable: true, filter: false, enableRowGroup: false, suppressHeaderMenuButton: true, width: 100, minWidth: 100, maxWidth: 100, filter: "agTextColumnFilter" },
            { key: "fullname", width: 70, headerName: this.label("Username"), field: "fullname", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { key: "department", width: 70, headerName: this.label("Department"), field: "department", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { key: "supervisor", width: 70, headerName: this.label("Supervisor"), field: "supervisor", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { key: "amount", width: 100, minWidth: 100, maxWidth: 100, headerName: this.label("Amount"), field: "amount", sortable: true, filter: false, enableRowGroup: false, suppressHeaderMenuButton: true, filter: "agTextColumnFilter", type: 'rightAligned', valueFormatter: this.nrFormatter },
        ]

        return cols;
    }

    refreshClicked = () => {
        this.props.loadDelegatedWaitingForApprovalReports();
        this.props.loadUserCounters();
    }

    render() {
        const loading = this.props.loadingReports;
        const menuHeight = 45
        const gridHeight = this.props.contentHeight - menuHeight - (this.props.topOffset || 0);
        const columnDefinitions = this.getGridCols();

        return (
            <div className='approvalreports'>
                <Row className='main-toolbar' style={{ height: menuHeight }} justify="space-around" align='middle' gutter={8}>
                    <Col span={24} >
                        <span className='module-title'>{this.label("DelegatedWaitingForApprovalReports")}</span>
                    </Col>
                </Row>
                {loading ? (
                    <div className="loader-content" >
                        <Spin size="large" />
                        <p>{this.label("Loading")}</p>
                    </div>
                ) : (
                    <>
                        <AgGridWithState height={gridHeight} ShowGroupPanel={false} DefaultExpanded={true}
                            lang={this.props.curLanguage}
                            onItemSelected={this.onSelect}
                            onItemDoubleClicked={this.onDoubleClick}
                            columnDefinitions={columnDefinitions}
                            data={this.props.delegatedreports}
                            onRefresh={this.refreshClicked}
                            labels={this.props.labels}
                            frameworkComponents={{
                                'rendererBoolean': RendererBoolean, 'rendererStatus': RendererStatus
                            }}
                        >
                        </AgGridWithState>
                    </>
                )}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        loadingReports: state[constants.NAME].loadingReports,
        delegatedreports: state[constants.NAME].delegatedreports,
        contentHeight: state[uistate.constants.NAME].contentheight,
        labels: uistate.selectors.uiLabels(state),
        curLanguage: uistate.selectors.curLanguage(state),
        currentuser: state[currentuser.constants.NAME],
        picklists: globalappstate.selectors.allPicklists(state),
    };
}

export default connect(mapStateToProps,
    {
        loadDelegatedWaitingForApprovalReports,
        loadUserCounters,
    })(DelegatedWaitingForApprovalReportsGrid);